import {useEffect, useState} from "react";

/**
 * Tracks whether a specific keyboard key is currently pressed.
 */
export function useCheatKey(targetKey: string = "c") {
    const [cheatActive, setCheatActive] = useState(false);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key.toLowerCase() === targetKey.toLowerCase()) {
                setCheatActive(true);
            }
        };

        const handleKeyUp = (event: KeyboardEvent) => {
            if (event.key.toLowerCase() === targetKey.toLowerCase()) {
                setCheatActive(false);
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        window.addEventListener("keyup", handleKeyUp);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
            window.removeEventListener("keyup", handleKeyUp);
        };
    }, [targetKey]);

    return cheatActive;
}
